import * as tslib_1 from "tslib";
import { OnInit, OnDestroy, AfterViewInit, EventEmitter, } from "@angular/core";
import { Actions, ofActionSuccessful, Select, Store } from "@ngxs/store";
import { Observable, Subject } from "rxjs";
import { AddLineItemToShoppingCart } from "../../../shopping-cart/actions/shopping-cart.actions";
import { SelectedVariantQuantityChange, RequestEvaluationCopy, RequestEvaluationCopyError, RequestEvaluationCopySuccess, ToggleTab, OnSelectedVariantChange, ComputePriceForOrderTemplate, } from "../../actions/product-details.actions";
import { takeUntil, debounceTime, switchMap, map } from "rxjs/operators";
import { NzMessageService } from "ng-zorro-antd";
import { AuthTokenState } from "src/app/auth/state/auth-token.state";
import { UtilsService } from "../../../snatch/services/utils.service";
import { PublishToLxpFormService } from "src/app/common/common-product/services/publish-to-lxp-form.service";
import { LxpPublishingService } from "src/app/common/common-product/services/lxp-publishing.service";
import { CoreState } from "src/app/core/state/core.state";
import { Router } from "@angular/router";
const ɵ0 = (state) => state.productDetails.selectedVariantQuantityChangePending, ɵ1 = (state) => state.productDetails.orderTemplatePricing, ɵ2 = (state) => state.shoppingCart.addLineItemPending, ɵ3 = (state) => state.productDetails.details, ɵ4 = (state) => state.productDetails.licenseForm, ɵ5 = (state) => state.core.dictionaries.currencySignsMap, ɵ6 = (state) => state.domain.domainConfiguration;
export class CartFormComponent {
    constructor(utilService, store, actions$, message, publishToLxpFormService, lxpPublishingService, router) {
        this.utilService = utilService;
        this.store = store;
        this.actions$ = actions$;
        this.message = message;
        this.publishToLxpFormService = publishToLxpFormService;
        this.lxpPublishingService = lxpPublishingService;
        this.router = router;
        this.onModalClose = new EventEmitter();
        this.updateProductDetails = new EventEmitter();
        this.quantity = 1;
        this.ngUnsubscribe = new Subject();
        this.quantityInputSubject = new Subject();
        this.quantityInputObservable = this.quantityInputSubject
            .asObservable()
            .pipe(debounceTime(500), takeUntil(this.ngUnsubscribe));
        this.showAddToOrderTemplateModal = false;
        this.showAddToTemplateBtn = true;
    }
    ngOnInit() {
        this.domainConfiguration$.subscribe((data) => {
            if (data && data.supportEmail) {
                this.supportEmail = data.supportEmail;
            }
            else {
                this.supportEmail = "support@edcast.com";
            }
        });
        let productRestrictions = this.product.restriction || null;
        this.addToBasketDisabled =
            productRestrictions &&
                productRestrictions.restricted &&
                (!productRestrictions.hasAccess ||
                    productRestrictions.isNotContractedSupplier);
        this.listenToEvaluationCopyRequest();
        this.listenToVariantChange();
        this.quantityInputObservable.subscribe((_) => this.store.dispatch(new SelectedVariantQuantityChange(this.selectedVariant.sku, this.quantity)));
        this.canBePublishedToLxp$ = this.isPermittedToPublishToLxp$.pipe(map((isPermittedToPublishToLxp) => (!this.product.restriction ||
            ((!this.product.restriction.restricted ||
                this.product.restriction.hasAccess) &&
                !this.product.restriction.isNotContractedSupplier)) &&
            this.product.enabledForLxp &&
            isPermittedToPublishToLxp));
    }
    ngAfterViewInit() {
        this.setCardPosition();
    }
    listenToVariantChange() {
        this.actions$
            .pipe(ofActionSuccessful(OnSelectedVariantChange), takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.quantity = 1;
            this.showAddToTemplateBtn = true;
        });
    }
    listenToEvaluationCopyRequest() {
        this.actions$
            .pipe(ofActionSuccessful(RequestEvaluationCopySuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.message.create("success", "Evaluation copy requested.");
        });
        this.actions$
            .pipe(ofActionSuccessful(RequestEvaluationCopyError), takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.message.create("error", "Sorry! Something went wrong.");
        });
    }
    addToCart() {
        this.store.dispatch(new AddLineItemToShoppingCart(this.selectedVariant.sku, this.quantity));
    }
    goToHowToAccess() {
        this.store.dispatch(new ToggleTab("how-to-access"));
        this.utilService.scrollToElementID("all-tabs");
    }
    requestEvaluationCopy() {
        const userEmail = this.profile.employee.email;
        this.store.dispatch(new RequestEvaluationCopy(this.selectedVariant.sku, userEmail));
    }
    login() {
        this.router.navigate(['login']);
    }
    setCardPosition() {
        const wrap = document.querySelector(".card");
        window.onscroll = function () {
            if (window.pageYOffset >= document.body.scrollHeight - 1000) {
                wrap.classList.remove("position-fixed");
                wrap.classList.add("position-absolute-bottom");
            }
            else {
                wrap.classList.add("position-fixed");
                wrap.classList.remove("position-absolute-bottom");
            }
        };
    }
    productQuantityChangeForOrderTemplates({ sku, quantity }) {
        this.store.dispatch(new ComputePriceForOrderTemplate(sku, quantity));
    }
    showAddToOrderTemplateOptions() {
        this.showAddToOrderTemplateModal = true;
    }
    hideAddToOrderTemplateOptions() {
        this.showAddToOrderTemplateModal = false;
        this.showAddToTemplateBtn = false;
        this.onModalClose.emit();
    }
    editLxpProduct() {
        this.lxpPublishingService
            .getLxpProductDetails(this.product.sku)
            .pipe(switchMap((res) => {
            const lxpProductDetails = {
                channels: res.data.channels,
                groups: res.data.groups,
                transactionType: {
                    key: res.data.transactionType.configKey,
                    value: res.data.transactionType.configValue,
                },
                approvalRequired: res.data.approval,
                approvalRule: res.data.approvalPolicy,
            };
            return this.publishToLxpFormService.editLxpProduct(this.product, lxpProductDetails, res.data.id);
        }))
            .subscribe();
    }
    publsihToLxp() {
        if (this.isProductBundle) {
            this.publishToLxpFormService
                .publishBundleToLxp(this.product)
                .subscribe(() => {
                this.updateProductDetails.emit({ publishedToLxp: true });
            });
            return;
        }
        this.publishToLxpFormService
            .publishProductToLxp(this.product)
            .subscribe(() => {
            this.updateProductDetails.emit({ publishedToLxp: true });
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
tslib_1.__decorate([
    Select(ɵ0),
    tslib_1.__metadata("design:type", Observable)
], CartFormComponent.prototype, "selectedVariantQuantityChangePending$", void 0);
tslib_1.__decorate([
    Select(ɵ1),
    tslib_1.__metadata("design:type", Observable)
], CartFormComponent.prototype, "orderTemplatePricing$", void 0);
tslib_1.__decorate([
    Select(ɵ2),
    tslib_1.__metadata("design:type", Observable)
], CartFormComponent.prototype, "addLineItemPending$", void 0);
tslib_1.__decorate([
    Select(ɵ3),
    tslib_1.__metadata("design:type", Observable)
], CartFormComponent.prototype, "details$", void 0);
tslib_1.__decorate([
    Select(ɵ4),
    tslib_1.__metadata("design:type", Observable)
], CartFormComponent.prototype, "licenseForm$", void 0);
tslib_1.__decorate([
    Select(ɵ5),
    tslib_1.__metadata("design:type", Observable)
], CartFormComponent.prototype, "currencySignsMap$", void 0);
tslib_1.__decorate([
    Select(CoreState.isPermittedToPublishToLxp),
    tslib_1.__metadata("design:type", Observable)
], CartFormComponent.prototype, "isPermittedToPublishToLxp$", void 0);
tslib_1.__decorate([
    Select(AuthTokenState.isLogged),
    tslib_1.__metadata("design:type", Observable)
], CartFormComponent.prototype, "isLogged$", void 0);
tslib_1.__decorate([
    Select(ɵ6),
    tslib_1.__metadata("design:type", Observable)
], CartFormComponent.prototype, "domainConfiguration$", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6 };
